export default __webpack_public_path__ + "static/media/referralcode.9cb0aa68.svg";